'use client';

import React from 'react';
import styles from '../../insiderTrades.module.scss';

type Option = { value: string; label: string };

export function InsiderFilterSelect({
  id,
  label,
  ariaLabel,
  value,
  onValueChange,
  options,
  disabled = false,
}: {
  id: string;
  label: string;
  ariaLabel: string;
  value: string;
  onValueChange: (next: string) => void;
  options: readonly Option[];
  disabled?: boolean;
}) {
  return (
    <div className={styles['filter-group']}>
      <label className={styles['filter-label']} htmlFor={id}>
        {label}
      </label>
      <select
        id={id}
        className={styles['filter-select']}
        aria-label={ariaLabel}
        value={value}
        disabled={disabled}
        onChange={e => onValueChange(e.target.value)}
      >
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
